// ** React Imports
import { useContext, useEffect, useState } from "react"
import { useIntl } from "react-intl"
import { Input, Label, Card, CardBody, Button } from 'reactstrap'
import { useReactOidc } from "@axa-fr/react-oidc-context"

// ** Custom Components
import Loading from "@views/common/Loading"
import Notification from "@views/common/Notification"
import { alertCustom } from "@views/common/NotificationClient"

// ** Context
import { IntlContext } from "@src/utility/context/Internationalization"

// ** Third Party Components
import { findPersonInfo } from '@services/PersonService'
import { getVerifyOTPPhone, confirmVerifyPhone } from "@services/VerifyService"

const VerifyPhone = () => {
    const intl = useIntl()
    const { oidcUser, login } = useReactOidc()
    const intlContext = useContext(IntlContext)
    const headers = {
        Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
        "Accept-Language": intlContext.locale
    }

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [valueOtp, setValueOtp] = useState('')
    const [loginInformation, setLoginInformation] = useState([])

    useEffect(() => {
        login()
    }, [])

    useEffect(() => {
        intlContext.switchLanguage("vi")
    }, [intlContext])

    useEffect(() => {
        if (oidcUser) {
            login()
        }
    }, [oidcUser])

    useEffect(() => {
        findPersonInfo(headers)
            .then((res) => {
                const loginInfo = res?.data?.loginInformation?.filter((item) => item?.id === oidcUser?.profile?.sub)
                setLoginInformation(loginInfo)
                getVerifyOTPPhone(headers, {
                    phone: loginInfo[0]?.phone
                })
            })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
            })
    })

    const getOtpVerifyPhoneSame = () => {
        setLoading(true)
        getVerifyOTPPhone(headers, {
            phone: loginInformation[0]?.phone
        }).then((res) => {
            alertCustom("success", `${intl.formatMessage({ id: "layOtpNumber" })}`)
        })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
            })
    }

    const confirmVerifyPhoneNumberSame = () => {
        setLoading(true)
        confirmVerifyPhone(headers, {
            otp: valueOtp,
            phone: loginInformation[0]?.phone
        })
            .then((res) => {
                alertCustom("success", `${intl.formatMessage({ id: "xacThucSDTThanhCong" })}`)
                window.parent.postMessage("success-verify", "*")
                setLoading(true)
            })
            .catch((err) => {
                setError(err)
            })
            .finally(() => {
                setError(null)
                setLoading(false)
                setValueOtp('')
            })
    }

    return (
        <Card className="mb-0">
            {loading && <Loading />}
            {error && <Notification data={{ error }} />}
            <CardBody>
                <div>
                    <h6 className="mb-1">{intl.formatMessage({ id: "noteVerify" })}</h6>
                    <Input
                        placeholder={intl.formatMessage({ id: "maOTP" })}
                        value={valueOtp}
                        type="number"
                        maxLength="10"
                        onChange={(e) => setValueOtp(e.target.value)}
                    />
                    <Label className="label mt-1">
                        {intl.formatMessage({ id: "noOtp" })}?{" "}
                        <Label
                            style={{
                                color: "#0951ff",
                                textDecorationLine: "underline",
                                cursor: 'pointer'
                            }}
                            onClick={() => getOtpVerifyPhoneSame()}
                        >
                            {intl.formatMessage({ id: "resend" })}
                        </Label>
                    </Label>
                </div>
                <div className="d-flex justify-content-center">
                    {valueOtp !== '' && (
                        <Button color="primary" onClick={() => confirmVerifyPhoneNumberSame()}>
                            {intl.formatMessage({ id: "verify" })}
                        </Button>
                    )}

                    {valueOtp === '' && (
                        <Button color="primary" disabled>
                            {intl.formatMessage({ id: "verify" })}
                        </Button>
                    )}
                </div>
            </CardBody>
        </Card>
    )
}

export default VerifyPhone